<template>
  <v-card>
    <v-toolbar>
      <v-row class="mt-7">
        <v-col>
          <v-toolbar-title>POIs</v-toolbar-title>
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <v-select
            :items="$store.state.ClientAppStore.apps"
            v-model="selectedAppId"
            :key="selectedAppId"
            label="App"
            item-text="name"
            item-value="id"
            @change="changeSelectedApp()"
            outlined
            dense
          ></v-select>
        </v-col>
      </v-row>
    </v-toolbar>
    <v-card-text>
      <v-list-item>
        <v-list-item-content>
          <poi-list :poi-list="this.$store.state.PoiStore.pois"></poi-list>
        </v-list-item-content>
      </v-list-item>
    </v-card-text>
  </v-card>
</template>

<script>
import PoiList from '../components/RecordLists/PoiList'

export default {
  components: {
    PoiList
  },
  data() {
    return {
      name: 'Poi List',
      selectedAppId: 0
    }
  },
  created:
    // function() {
    // v 2
    // this.$store.dispatch("ClientAppStore/fetchClientApps").then(() => {
    //   this.$store
    //     .dispatch(
    //       "ClientAppStore/selectClientApp",
    //       this.$store.state.ClientAppStore.apps[0].id
    //     )
    //     .then(() => {
    //       this.selectedAppId = this.$store.state.ClientAppStore.selectedApp.id;
    //       this.$store.dispatch("PoiStore/fetchPois");
    //       //this.$store.dispatch("PoiStore/fetchPoiTypes");
    //     });
    // });

    // v 1
    async function() {
      await this.$store.dispatch('ClientAppStore/fetchClientApps')
      await this.$store.dispatch(
        'ClientAppStore/selectClientApp',
        this.$store.state.ClientAppStore.apps[0].id
      )
      this.selectedAppId = this.$store.state.ClientAppStore.selectedApp.id
      await this.$store.dispatch('PoiStore/fetchPois')
      // await this.$store.dispatch("PoiStore/fetchPoiTypes");
    },
  methods: {
    changeSelectedApp: async function() {
      await this.$store.dispatch(
        'ClientAppStore/selectClientApp',
        this.selectedAppId
      )
      await this.$store.dispatch('PoiStore/fetchPois')
    }
  }
}
</script>

<style scoped></style>
